/******************************************************************************************
 *	Plan Type Icon Directive
 *******************************************************************************************
 *
 * Converts a string (e.g. TEAM or EVIP) to a <span> element with a class (e.g. <span class="icon-enterprise"></span>).
 * The match is made using data in the RESELLER_PLAN_TYPES constant.
 * In addition, If a show-icon-label="true" attribute is set, the element will also contain the label for icon (e.g. <span class="icon-enterprise">Enterprise</span>).
 *
 * This is currently set up to take either null or an array of RESELLER_PLAN_TYPES strings as the planTypeIcon data.
 * In practice, this is the customer's normalizedPlanTypes value which is present in all segments.
 */
(function() {
  

  angular.module('rcDirectives.planTypeIcon', []).directive(
    'planTypeIcon',
    /* @ngInject */
    function(ResellerPlanTypes) {
      return {
        restrict: 'AE',
        replace: true,
        scope: {
          centered: '=',
          planTypes: '=planTypeIcon'
        },
        templateUrl: 'templates/plan-type-icon.html',
        link: function(scope, element, attrs) {
          scope.showLabel = attrs.showIconLabel === 'true';

          scope.noPlanType = !scope.planTypes || scope.planTypes.length <= 0;

          // To maintain consistency of icon ordering, sort the array, if more than one plan type.
          if (scope.planTypes && scope.planTypes.length > 1) {
            scope.planTypes = ResellerPlanTypes.sortPlanTypes(scope.planTypes);
          }

          scope.getPlanType = function(planTypeCode) {
            return ResellerPlanTypes.getPlanType(planTypeCode);
          };

          scope.resellerPlanTypeLabel = ResellerPlanTypes.getResellerPlanTypeLabel(scope.planTypes);
        }
      };
    }
  );
})();
